import React, { useMemo } from "react";
import { useEditLock } from "../../context/EditLockContext";
import { pickUnlockIcon } from "../../config/unlockIcons";

/**
 * Collapsed “writing pane” when edit-locked. Five taps on the icon unlocks this device.
 */
export default function UnlockSeal({ size = 88, hint = true, className = "" }) {
  const { canEdit, registerUnlockTap, tapProgress, tapGoal } = useEditLock();
  const iconSrc = useMemo(() => pickUnlockIcon(), []);

  if (canEdit) return null;

  const remaining = Math.max(0, tapGoal - tapProgress);

  return (
    <button
      type="button"
      className={`unlock-seal ${className}`.trim()}
      onClick={registerUnlockTap}
      aria-label={`Desbloquear escritura. ${remaining} toques restantes.`}
      title={remaining > 0 ? `${remaining} toques más` : "Desbloquear"}
    >
      <span className="unlock-seal__ring" style={{ width: size + 24, height: size + 24 }}>
        <img
          src={iconSrc}
          alt=""
          className="unlock-seal__img"
          style={{ width: size, height: size }}
          draggable={false}
        />
      </span>
      {hint && (
        <span className="unlock-seal__hint">
          {tapProgress > 0 ? `${remaining} más…` : "Tocá 5 veces para escribir"}
        </span>
      )}
      <span className="unlock-seal__dots" aria-hidden>
        {Array.from({ length: tapGoal }).map((_, i) => (
          <span key={i} className={`unlock-seal__dot${i < tapProgress ? " unlock-seal__dot--on" : ""}`} />
        ))}
      </span>
    </button>
  );
}
